export const createMandate = (payload) => {
    return ApiClient.post('/account/e-invoicing/mandate', {}, payload);
};

export const getEInvoicingStatus = () => {
    return ApiClient.get('/account/e-invoicing/status');
};

export const getEInvoicingMandate = () => {
    return ApiClient.get('/account/e-invoicing/mandate');
};

export const deletePendingEInvoicingMandate = () => {
    return ApiClient.del('/account/e-invoicing/mandate');
};

export const resendMandateSignatureEmail = () => {
    return ApiClient.post('/account/e-invoicing/mandate/send-email');
};
